/* eslint-disable import/prefer-default-export */
export const SET_CHAT_CLIENT = 'SET_CHAT_CLIENT'
export const SUPPORTED_MEDIA_TYPES = ['.jpeg', '.jpg', '.png', '.pdf', '.doc', '.docx']
export const MAX_FILE_SIZE = 8388608 // 8MB
export const ANDROID = 'Android'
export const MIN_OS_VERSION_SUPPORT_CHAT = 19
